var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.allPanels),function(panel){return _c(panel.panelName,_vm._b({key:'pan' + panel.id,tag:"component"},'component',{data: panel},false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }